import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Img } from 'react-image';
import { SectionName, PaddedContainer } from '../common/styles';

const heroLandscapeAspectRatio = 2882 / 1416;
const heroPortraitAspectRatio = 774 / 992;
const sectionNamePositionRatio = 183 / 496;
const containerHeightVWDesktop = 100 / heroLandscapeAspectRatio;
const containerHeightVWMobile = 100 / heroPortraitAspectRatio;

const Container = styled.div`
  margin-top: ${props => (props.theme.isMobile ? '0' : '-70px')};
  position: relative;
  top: 0;
  width: 100vw;
  height: ${props => (props.theme.isMobile
    ? `${containerHeightVWMobile}vw`
    : `calc(${containerHeightVWDesktop}vw - 130px)`
  )};
  display: flex;
  flex-direction: column;
  align-items: center;
  ${props => (props.theme.isMobile && `
    border-bottom-right-radius: 150px;
    overflow: hidden;
  `)};
`;

const Image = styled(Img)`
  position: absolute;
  width: 100vw;
  z-index: 100;
  ${props => (!props.theme.isMobile && `
      margin-top: -130px;
  `)};
`;

const Intro = styled(PaddedContainer)`
  z-index: 150;
  ${props => (props.theme.isMobile ? `
    position: relative;
    height: ${containerHeightVWMobile}vw;
    display: flex;
    flex-direction: column;
    padding-top: ${containerHeightVWMobile * sectionNamePositionRatio}vw;
  ` : `
    position: absolute;
    margin-top: 12%;
    margin-left: -7px;
  `)};
`;

const Desc = styled.p`
  position: relative;
  ${props => (!props.theme.isMobile && `
    width: 630px;
  `)};
  margin-top: 20px;
  color: white;
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: ${props => (props.theme.isMobile ? 35 : 44)}px;
  line-height: ${props => (props.theme.isMobile ? 46 : 56)}px;
`;

export default function Hero() {
  const {
    hero, heroPortrait, isMobile,
  } = React.useContext(ThemeContext);

  return (
    <Container>
      <Image src={isMobile ? heroPortrait : hero} />
      <Intro>
        <SectionName>features</SectionName>
        <Desc>Content to help discover, evaluate and monitor your next investment.</Desc>
      </Intro>
    </Container>
  );
}
